<template>
    <div class="app header-primary">
        <div class="layout">
            <div class="page-container">
                <div class="main-content">
                    <div class="container-fluid">
                        <router-view/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainPage",
        metaInfo() {
            return {
                title: this.$i18n.t('Dashboard')
            }
        },
    }
</script>
